// extracted by mini-css-extract-plugin
module.exports = {"syncing":"LanguageManagement_syncing__3iZzt","listLoading":"LanguageManagement_listLoading__2HTPw","emptyState":"LanguageManagement_emptyState__3QFJE"};